import { render, staticRenderFns } from "./workflow.vue?vue&type=template&id=677be56e&"
import script from "./workflow.vue?vue&type=script&lang=ts&"
export * from "./workflow.vue?vue&type=script&lang=ts&"
import style0 from "./workflow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports